import { setStylesTarget } from "typestyle";

export const typeStyleTargetId = "typeStyleContainer";

export function setupTypeStyle() {
  const typeStylesTarget = document.createElement("style");
  typeStylesTarget.id = typeStyleTargetId;

  setStylesTarget(typeStylesTarget);
  document.head.appendChild(typeStylesTarget);
}
